import React from 'react';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import type { PlanTermWorkingTimeProps } from '../context';
import PlanTermContext, { PlanTermContextProps } from './context';
import T from 'i18n-react';

const useStyles = makeStyles(() => ({
  container: {
    marginBottom: '20px',
  },
  item: {
    marginTop: '4px',
  },
}));

type WorkingTimesProps = {
  times: PlanTermWorkingTimeProps[];
  className: string;
};

const WorkingTimes = ({ times, className }: WorkingTimesProps) => {
  return (
    <>
      {times.map(
        ({ id, startTimeText, endTimeText, workingTimeText }, index) => (
          <Typography key={`${id || 'noId'}-${index}`} className={className}>
            {T.translate('planPage.planTerms.workingTimeRangeText', {
              startTime: startTimeText,
              endTime: endTimeText,
            })}
            {workingTimeText &&
              T.translate('planPage.planTerms.workingTimeText', {
                workingTime: workingTimeText,
              })}
          </Typography>
        ),
      )}
    </>
  );
};

const Schedule = () => {
  const classes = useStyles();
  const { planTerm } = React.useContext<PlanTermContextProps>(PlanTermContext);
  const workingTimes: PlanTermWorkingTimeProps[] = planTerm.workingTimes || [];

  return (
    <>
      {/* 就業時間 */}
      {planTerm.isRegistWorkingTime && (
        <Typography component="div" className={classes.container}>
          <Typography>{T.translate('planPage.planTerms.hours')}</Typography>
          <Typography className={classes.item}>
            {T.translate('planPage.planTerms.hoursText', {
              startTime: planTerm.startTimeText,
              endTime: planTerm.endTimeText,
              workingTime: planTerm.totalTimesText,
            })}
          </Typography>
        </Typography>
      )}

      {/* シフト例 */}
      <Typography component="div" className={classes.container}>
        <Typography>
          {T.translate('planPage.planTerms.workingTimeHours')}
        </Typography>

        <WorkingTimes times={workingTimes} className={classes.item} />
      </Typography>

      {planTerm.hasOvertimeWork && (
        <Typography component="div" className={classes.container}>
          <Typography>
            {T.translate('planPage.planTerms.hasOvertimeWorkText')}
          </Typography>
        </Typography>
      )}
    </>
  );
};

export default Schedule;
